import { render } from "./NestedLocation.vue?vue&type=template&id=38d4b716&ts=true"
import script from "./NestedLocation.vue?vue&type=script&lang=ts"
export * from "./NestedLocation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__